import React, { useCallback } from "react";
import _includes from "lodash/includes";
//
import { minDuration } from "../config";
import { getHumanDuration } from "../utils";
import Screen from "./ConnectedScreen";
import DurationPicker from "../components/DurationPicker";
import PremiumAlert from "./PremiumAlert";
import Alert from "../components/Alert";

function goToNext(model, bookModel, getModels) {
  if (model && model.online) {
    bookModel(model.id);
  } else {
    getModels();
  }
}

function DurationScreen({
  isLoading,
  isPremiumDuration,
  duration,
  model,
  setDuration,
  durations,
  rates,
  bookModel,
  getModels,
}) {
  const onNext = useCallback(() => goToNext(model, bookModel, getModels));

  let nextLabel;

  if (model && model.online) {
    nextLabel = isLoading ? "Checking..." : `Book ${model.name}`;
  } else {
    nextLabel = isLoading ? "Searching..." : "Search";
  }

  const noRate = rates.length > 0 && !_includes(rates, duration);

  return (
    <Screen
      {...{
        title: "Select duration",
        isActive: true,
        nextLabel,
        nextDisabled: isLoading || isPremiumDuration || noRate,
        onNext,
      }}
    >
      <DurationPicker
        value={duration}
        steps={durations}
        onChange={(value) => setDuration(value)}
      />
      {isPremiumDuration && (
        <PremiumAlert
          className="u-mt-large"
          text="1h duration searches are only available for _Premium members_"
        />
      )}
      {noRate && (
        <Alert
          error
          className="u-mt-large"
          text={`**${model.name}** does not accept ${getHumanDuration(
            duration
          )} bookings`}
        />
      )}
    </Screen>
  );
}

// @connect
import { connect } from "react-redux";
import { bindActionCreators as bindActions } from "redux";
//
import {
  isComplimentaryCity,
  getModel,
  getModelOutcalls,
  getModelIncalls,
  isPremiumIn,
} from "../selectors";

const props = (state) => {
  const { booking, intl } = state;

  const model = getModel(state);

  let durations;

  if (booking.outcall) {
    if (intl.cityId === 12) {
      // Tokyo
      durations = [60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360];
    } else {
      durations = [60, 120, 180, 240, 360, 480, 600, 720, 900, 1440];
    }
  } else {
    if (intl.cityId === 12) {
      // Tokyo
      durations = [15, 30, 45, 60, 90, 120, 150, 180, 210, 240];
    } else {
      durations = [15, 30, 45, 60, 120, 180, 240, 360, 480, 600];
    }
  }

  let rates = [];

  if (model) {
    if (booking.outcall) {
      rates = getModelOutcalls(state);
    } else {
      rates = getModelIncalls(state);
    }

    rates = rates.map((rate) => rate.duration);
  }

  const isPremium = isPremiumIn(state);

  return {
    duration: booking.duration,
    model,
    durations,
    rates,
    isPremiumDuration:
      booking.outcall &&
      booking.duration === minDuration &&
      !isPremium &&
      !isComplimentaryCity(state),
  };
};

import { setDurationAction } from "../modules/booking/actions";
import { getModelsAction, bookModelAction } from "../modules/models/actions";

const actions = (dispatch) =>
  bindActions(
    {
      setDuration: setDurationAction,
      getModels: getModelsAction,
      bookModel: bookModelAction,
    },
    dispatch
  );

export default connect(props, actions)(DurationScreen);
